export default (msg, $store) => {
  const { commit } = $store;

  commit('_setConversationTerminated', msg);
};
